import React from "react";
import Img from "gatsby-image";
import PageSectionContainer from "../common/page-section-container";
import PageSectionHeading from "../common/page-section-heading";
import AuthorNames from "../author-names";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
var FeaturedMagazine = function FeaturedMagazine(_ref) {
    var to = _ref.to, title = _ref.title, shortDescription = _ref.shortDescription, description = _ref.description, authors = _ref.authors, image = _ref.image;
    return /*#__PURE__*/ React.createElement("div", {
        className: "`flex flex-wrap mb-8 w-full"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        to: to
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: replaceQuotationMarksWithGuillemets(title),
        className: "z-10 h-8 xl:h-10"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "w-full bg-makroYellow break-words pt-8 -mt-8 lg:pl-8 lg:w-4/12 xl:pt-10 xl:-mt-10",
        style: {
            fontSize: "2.5rem",
            hyphens: "manual"
        }
    }, shortDescription), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-1 lg:pl-16 lg:pr-8 lg:w-5/12 xl:pl-24 xl:pr-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content-text font-bold h0 normal-line-height mb-4",
        dangerouslySetInnerHTML: {
            __html: description
        }
    }), /*#__PURE__*/ React.createElement(AuthorNames, {
        authors: authors,
        link: false,
        isMagazine: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-2 lg:-mt-8 xl:-mt-10 lg:w-3/12 xl:pl-0"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: image,
        className: "w-full shadow-magazines max-w-sm lg:max-w-none"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-center mt-16"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "btn-makroYellow inline-block font-medium text-xl mx-auto px-8 py-4"
    }, "ZUM THEMENHEFT"))))));
};
export default FeaturedMagazine;
